import { useMemo } from "react";
import { useStableRest } from "../../utils/use-stable-rest";
import type { PageHeaderProps, PageHeaderViewModel } from "./types-page-header";

/** ViewModel do PageHeader.Root: variante, atributo de impressão, classes por parte e testids derivados; sem JSX. */
export function usePageHeader({
  printHide = false,
  variant = "page",
  testId,
  className,
  style,
  classNames,
  ...props
}: Omit<PageHeaderProps, "children"> = {}): PageHeaderViewModel {
  const rest = useStableRest(props);
  return useMemo(
    () => ({
      printHide,
      variant,
      testId,
      className,
      style,
      classNames: classNames ?? {},
      rest,
      partTestId: (part: string) => (testId ? `${testId}-${part}` : undefined),
    }),
    [printHide, variant, testId, className, style, classNames, rest],
  );
}
